function adjust_footer(){
	am.$('#footer').addClass('footer-sticky-button');
}

function annimate_bot(bot, annimation, sidebar = false){
	ensureGSAP().then(function(){
		var el = bot[0]; // Extract DOM element from jQuery object for GSAP
		if (!el) return;
		if(!sidebar){
			const timeline = gsap.timeline({ defaults: {duration: .5}})
				timeline
					.to(el, annimation, 'start')
					.to('.am-button-row-sticky', {opacity: 1, height: '58px', lineHeight: '58px'}, 'start')
		}else{
			const timeline = gsap.timeline({ defaults: {duration: .5}})
				timeline
					.to(el, annimation, 'start')
		}
	});
}

function animate_stickybar(){
	if (!document.querySelector('.am-button-row-sticky')) return;
	ensureGSAP().then(function(){
		const timeline = gsap.timeline({ defaults: {duration: .5}})
		timeline
			.to('.am-button-row-sticky', {opacity: 1, height: '58px', lineHeight: '58px'}, 'start')
	});
}

function confirm_sticky_shown() {
	// One-time deferred check instead of forever-polling.
	// 1500ms allows for GSAP lazy-load (~500ms) + animation (500ms) + buffer.
	setTimeout(function() {
		var el = document.querySelector('.am-button-row-sticky');
		if (!el) return;
		var style = window.getComputedStyle(el);
		if (parseFloat(style.opacity) === 0 || style.height === '0px') {
			animate_stickybar();
		}
	}, 1500);
}

function get_zendesk_bot($bot, timer){
	var $bot2Div = $bot.next();
	if($bot2Div.length > 0) {
		var divs = $bot2Div.children();
		divs.each(function(){
			var $this = am.$(this);
			if($this.children().length > 0){
				var $n_bot = $this.children('iframe');
				var $n_bot_div = $this.children('div');
				if(am.$('.am-button-row-sticky').length > 0){
					annimate_bot($n_bot, {bottom: '80px'});
					if($n_bot_div.length > 0)
						annimate_bot($n_bot_div, {bottom: '154px'});
				}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
					annimate_bot($n_bot, {left: '15px'}, true);
					if($n_bot_div.length > 0)
						annimate_bot($n_bot_div, {left: '15px', width: 'fit-content'}, true);
				}else{
					animate_stickybar();
				}
			}
			else{
				animate_stickybar();
			}
		})
		clearTimeout(timer);
		confirm_sticky_shown();
	}
}

function ensureJqueryWatch() {
	if (window._jqWatchPromise) return window._jqWatchPromise;
	if (am.$.fn.watch) return window._jqWatchPromise = Promise.resolve();
	window._jqWatchPromise = new Promise(function(resolve, reject) {
		var s = document.createElement('script');
		s.src = window._cdnBase + 'jquery_addons/jquery-watch.js?v=' + window._cdnV;
		s.onload = resolve;
		s.onerror = reject;
		document.head.appendChild(s);
	});
	return window._jqWatchPromise;
}

function animate_hubspot_bot($bot, timer){
	ensureJqueryWatch().then(function(){
		$bot.watch({
			properties: "prop_innerHTML",
			callback: function(data, i) {
				if(am.$('html').hasClass('hs-messages-widget-open')){
					$bot.css({marginBottom: 0})
				}else{
					if(am.$('.am-button-row-sticky').length > 0){
						annimate_bot($bot, {marginBottom: '60px'})
					}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
						annimate_bot($bot, {left: '0'}, true)
					}else{
						animate_stickybar();
					}
				}
			}
		});
	});

	clearTimeout(timer);
	confirm_sticky_shown();
}

function animate_respondio_bot($bot, timer){
	if(am.$('.am-button-row-sticky').length > 0){
		annimate_bot($bot, {marginBottom: '60px'})
	}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
		annimate_bot($bot, {left: '0'})
	}else{
		animate_stickybar();
	}

	clearTimeout(timer);
	confirm_sticky_shown();
}

function animate_tawkto_bot($bots, timer){
    var $bot = am.$($bots[0]);
    var chat = $bots[1];

	if(am.$('.am-button-row-sticky').length > 0){
		annimate_bot($bot, {bottom: '70px'})
        annimate_bot(chat, {left: '70px'});
	}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
		annimate_bot($bot, {left: '15px'})
        annimate_bot(chat, {left: '15px'});
	}else{
		animate_stickybar();
	}

	clearTimeout(timer);
	confirm_sticky_shown();
}

function animate_chatbot_bot($bot, timer){
	if(am.$('.am-button-row-sticky').length > 0){
		annimate_bot($bot, {position: '60px'})
	}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
		annimate_bot($bot, {left: '0'})
	}else{
		animate_stickybar();
	}

	clearTimeout(timer);
	confirm_sticky_shown();
}

function animate_tidio_bot($bot, timer){
		if(am.$('.am-button-row-sticky').length > 0){
			annimate_bot($bot, {marginBottom:'48px'})
		}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
			annimate_bot($bot, {left: '0'})
		}else{
			animate_stickybar();
		}
		
		var $buttonDiv = $bot.children().children('.frame-content').children();
		var $button = $buttonDiv.children('#button');
		$button.click(function(){

			setTimeout(function(){
				$exitButton = $button.siblings('.chat').children('.chat-header').children('.exit-chat');
				$exitButton.click(function(){
					$bot.css({marginBottom: '48px'})
				})
			}, 1000)
		});

	clearTimeout(timer);
	confirm_sticky_shown();
}

function animate_freshworks($cont, timer){
	const $bot = $cont.children('div').children('iframe#launcher-frame');
	$bot[0].contentWindow.document.onclick = function(){
		setTimeout(function(){
			const $chat = am.$('#freshworks-frame-wrapper');
			if(am.$('.am-button-row-sticky').length > 0){
				annimate_bot($chat, {marginBottom:'48px'})
			}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
				annimate_bot($chat, {left: '15px'})
			}
		}, 200)

		if(am.$('.am-button-row-sticky').length > 0){
			annimate_bot($bot, {marginBottom:'48px'})
		}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
			annimate_bot($bot, {left: '0'})
		}else{
			animate_stickybar();
		}
	}

	if(am.$('.am-button-row-sticky').length > 0){
		annimate_bot($bot, {marginBottom:'48px'})
	}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
		annimate_bot($bot, {left: '0'})
	}else{
		animate_stickybar();
	}

	clearTimeout(timer);
	confirm_sticky_shown();
}

function animate_sendinblue_bot($bot, timer){
	if(am.$('.am-button-row-sticky').length > 0){
		annimate_bot($bot, {marginBottom: '58px'})
	}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
		annimate_bot($bot, {left: '15px'})
	}else{
		animate_stickybar();
	}

	clearTimeout(timer);
	confirm_sticky_shown();
}

function animate_zoho_bot($bot, timer){
	$bot = $bot.children('#zsiq_float');
	if($bot.length > 0)
		$chat = am.$('#zsiq_chat_wrap');

	if(am.$('.am-button-row-sticky').length > 0){
		annimate_bot($bot, {marginBottom: '68px'})
		if(!is_mobile())
			annimate_bot($chat, {marginBottom: '68px'})
	}else if(am.$('.farrightbar').length > 0 && am.$('.am-button-row-sticky').length == 0){
		$bot = am.$('[data-id="zsalesiq"]'); // Overide the bot position at the grouped chat element level (Based on how zoho allows positions to their chatbot )
		if($bot.length > 0 && (!$bot.attr('position') || $bot.attr('position') != 'left-bottom')){
			$bot.fadeOut(500, function(){
				$bot.attr('position', 'left-bottom');
				$bot.fadeIn(250);
			});
		}
	}else if(am.$('.farleft').length > 0 && am.$('.am-button-row-sticky').length == 0){
		$bot = am.$('[data-id="zsalesiq"]'); // Overide the bot position at the grouped chat element level (Based on how zoho allows positions to their chatbot )
		if($bot.length > 0 && $bot.attr('position') == 'left-bottom'){
			$bot.fadeOut(500, function(){
				$bot.removeAttr('position');
				$bot.fadeIn(250);
			});
		}
	}else{
		console.log('else - animate_stickybar');
		animate_stickybar();
	}

	clearTimeout(timer);
	confirm_sticky_shown();
}

var CHATBOT_SELECTORS = {
	hubspot:    { selector: '#hubspot-messages-iframe-container', handler: animate_hubspot_bot },
	respondio:  { selector: 'iframe[state="widgetClose"]', handler: animate_respondio_bot },
	tawkto:     { selector: '.widget-visible', handler: animate_tawkto_bot, transform: function($el) { return $el.children('iframe'); } },
	chatbot:    { selector: '#chatbot-chat', handler: animate_chatbot_bot },
	sendinblue: { selector: '#brevo-conversations', handler: animate_sendinblue_bot },
	tidio:      { selector: '#tidio-chat iframe', handler: animate_tidio_bot },
	freshworks: { selector: '#freshworks-container', handler: animate_freshworks },
	zendesk:    { selector: 'body iframe[data-product="web_widget"]', handler: get_zendesk_bot },
	zoho:       { selector: '[data-id="zsalesiq"]', handler: animate_zoho_bot }
};

function check_for_bot(){
	var chatbot_option = am.$('body').data('chatbot');

	if (!chatbot_option || chatbot_option == 'livechat' || chatbot_option == 'intercom') {
		animate_stickybar();
		return;
	}

	var config = CHATBOT_SELECTORS[chatbot_option];
	if (!config) {
		animate_stickybar();
		return;
	}

	// Fast path: bot element may already exist (cached scripts)
	var $existing = am.$(config.selector);
	if ($existing.length > 0) {
		var $bot = config.transform ? config.transform($existing) : $existing;
		config.handler($bot, null);
		return;
	}

	// Watch for bot element to appear in the DOM (event-driven, zero cost when idle)
	var resolved = false;
	var observer = new MutationObserver(function() {
		if (resolved) return;
		var $bot = am.$(config.selector);
		if ($bot.length > 0) {
			resolved = true;
			observer.disconnect();
			clearTimeout(fallbackTimeout);
			if (config.transform) $bot = config.transform($bot);
			config.handler($bot, null);
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });

	// Fallback: if bot never appears, show the sticky bar after 4 seconds
	var fallbackTimeout = setTimeout(function() {
		if (!resolved) {
			resolved = true;
			observer.disconnect();
			animate_stickybar();
		}
	}, 4000);
}

window.addEventListener("DOMContentLoaded", (event) => { 
	check_for_bot();
});